export default {
  title: 'All Categories',
  attributeName: 'allCategories',
  getURL: '',
  createURL: '',
  updateURL: '',
  removeURL: '',
  itemName: 'name',
  itemId: 'id',
  itemType:'button',
  sessionParams: [],
};
